@use '~@frontrow/console/css/variables.scss';

.rosterItem {
  width: 790px;
  border: 1px solid variables.$gray-light-1;
  display: block;
  border-radius: 5px;
  text-align: left;
  padding: variables.$std-padding-md;
  margin: variables.$std-margin-xlg !important; /* Avoid link + link style */
}

.rosteItemContent {
  font-size: variables.$font-size-sm;
  color: #404041;
}

.rosteItemDescription:hover,
.rosteItemDescription:focus {
  color: #404041;
}

.rosterItemTitle {
  color: #428bca;
}
